import { createContext, useContext, useState } from "react";

const UserContext = createContext();

export function UserProvider({ children }) {
  const [adminName, setAdminName] = useState("");
  const [userRole, setUserRole] = useState(""); // 👈 نقش کاربر

  return (
    <UserContext.Provider value={{ adminName, setAdminName, userRole, setUserRole }}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  return useContext(UserContext);
}
